import { SmartTable } from '../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor(
        $filter,
        $state,
        $timeout,
        $uibModal,
        Alert,
        DestructiveOperationModal,
        HardTokenEditModal,
        HardTokenService,
        HardTokenResource
    ) {
        this.$filter = $filter;
        this.$state = $state;
        this.$timeout = $timeout;
        this.$uibModal = $uibModal;
        this.Alert = Alert;
        this.DestructiveOperationModal = DestructiveOperationModal;
        this.HardTokenEditModal = HardTokenEditModal;
        this.HardTokenService = HardTokenService;
        this.HardTokenResource = HardTokenResource;
    }

    $onInit() {
        this.filteredTokens = this.hardTokens;
        this.st = new SmartTable();
        this.filter = {type: undefined, otpType: undefined, state:undefined, effectiveStatus: undefined};
        // this.tokenStates = ['ACTIVE', 'INACTIVE', 'NOT_ASSIGNED'];
        this.tokenStates = ['secondary_device_of_user','secondary_device_of_user_blocked','has_assigned_accounts','has_assigned_accounts_blocked','no_account_assigned','no_account_assigned_blocked'];
        this.hardTokens.forEach(token=>token.state=this.getState(token));
    }

    filterBy(filter) {
        Object.assign(this.filter, filter);
        this.filteredTokens = this.$filter('filter')(this.hardTokens, this.filter, true);
    }

    showDeleteModal(token) {
        const companyId = this.companyId;
        const url = `app/rest/admin/company/${companyId}/hardtoken/${token.id}`;
        this.DestructiveOperationModal({
            titleKey: 'hard_tokens.management.delete',
            textKey: token.isSecondaryDeviceOfUser?'hard_tokens.management.info_secondarydevice':'hard_tokens.management.info',
            http: {method: 'DELETE', url}
        }).then(() => {
            this.$state.reload(this.$state.current);
            this.Alert('success', 'hard_tokens.management.delete.success');
        })
    }

	showEdit(token) {
		this.HardTokenService
            .getDetail(token.id)
            .then((data) => {
                token.secret = data.secret;
                token.privateIdentity = data.privateIdentity;
               this.$state.go('company.hard-token-management.edit', {token: token,hardTokenId: token.id});
            })
	}
    showEditModal(token) {
        this.editingToken = token;
        this.HardTokenService
            .getDetail(token.id)
            .then((data) => {
                token.secret = data.secret;
                token.privateIdentity = data.privateIdentity;
                this.HardTokenEditModal(token);
            })
            .finally(() => {
                this.editingToken = null;
            })
    }

    

    getState(token){
        if (token.isSecondaryDeviceOfUser){
            return token.status === 'ACTIVE' ? 'secondary_device_of_user' : 'secondary_device_of_user_blocked';
        }
        if (token.hasAccounts){
            return token.status === 'ACTIVE' ? 'has_assigned_accounts' : 'has_assigned_accounts_blocked';
        }
        return token.status==='ACTIVE' ? 'no_account_assigned' : 'no_account_assigned_blocked';
    }

    /*showHardTokenIntegrationModal() {
        this.$uibModal
            .open({component: 'integrateHardToken', size: 'xl'}).result
            .then(this.success.bind(this))
            .catch(this.dismissed.bind(this))
    }
    showFidoU2fIntegrationModal() {
        this.$uibModal
            .open({component: 'integrateFidoU2f', size: 'xl'}).result
            .then(this.success.bind(this))
            .catch(this.dismissed.bind(this))
    }*/

   /* showSyncModal(token) {
        this.$uibModal.open({
            component: 'companyHardTokenManagementSync',
            resolve: {token: () => token},
        })
    }*/
    /*showUsbTokenIntegrationModal() {
        this.$uibModal
            .open({component: 'integrateUsbToken', size: 'xl'}).result
            .then(this.success.bind(this))
            .catch(this.dismissed.bind(this))
    }*/

    /** @private */
    dismissed(reason) {
        if (reason === 'failed') {
            this.Alert('danger', 'hard_tokens.integrate.add_error');
        }
    }

    /** @private */
    success() {
        this.$state.reload(this.$state.current);
        this.Alert('success', 'hard_tokens.integrate.add_success');
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-management.controller.js